module.exports = __webpack_public_path__ + "static/media/small_icon.612e58ed.png";